// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

// Add properties to the expand parameters so custom properties are available in ProductSelector requests.
// This expansion also makes backend custom-property processing possible,
// for example setting a product's canAddToCart to false for generic products.
addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.apiParameter) {
        return;
    }

    const expand = props.apiParameter.expand || [];
    if (!expand.includes("properties")) {
        expand.push("properties");
    }

    props.apiParameter.expand = expand;
});
